<template>
    <h1
        class="text-2xl tablet-sm:text-5xl
               mb-1 pb-1 tablet-sm:mb-4 tablet-sm:pb-4 mx-0
               px-0 mobile-lg:px-1 mobile-lg:px-0 tablet-sm:px-2
               mobile-lg:mx-2 mt-2
               font-bold tracking-tight text-gray-900 sm:text-4xl"
    >
        <span class="border-b-2 border-accent font-title"><slot></slot></span>
    </h1>
</template>
